import { MESSAGE_TYPE } from '@protobuf-ts/runtime'
import { expandIndexFromPath } from 'lib/rpcts'
import { App } from 'pbts/c1/api/app/v1/app'
import { AppEntitlementView, GetAppEntitlementResponse } from 'pbts/c1/api/app/v1/app_entitlement'
import { AppResource, AppResourceType } from 'pbts/c1/api/app/v1/app_resource'
import { Any } from 'pbts/google/protobuf/any'
import { AnyMessage } from './utils'

interface AppEntitlementViewExpanded extends AppEntitlementView {
    app?: App
    appResourceType?: AppResourceType
    appResource?: AppResource
}

const EXPANSION_TYPES: Record<string, AnyMessage> = {}
const registerExpansionType = <T extends AnyMessage>(type: T): void => {
    EXPANSION_TYPES[`type.googleapis.com/${type.typeName}`] = type
}
const expandables = [App, AppResource, AppResourceType]
expandables.forEach(registerExpansionType)

export const expanderizeEntitlementResponse = (getEntitlementResponse: GetAppEntitlementResponse)
    : AppEntitlementViewExpanded => {
    const entitlementView = getEntitlementResponse.appEntitlementView
    if (!entitlementView) {
        throw new Error('Invalid `appEntitlementView` object in response!')
    }
    const expansionItems = getEntitlementResponse.expanded
    const expanded = { appEntitlement: { ...entitlementView.appEntitlement } }
    const { typeName } = entitlementView[MESSAGE_TYPE] as { typeName: string }
    // TODO: dev only
    if (!typeName) {
        throw new Error('invalid expansion object')
    }

    Object.keys(entitlementView).forEach((key: string) => {
        if (key.endsWith('Path')) {
            const newFieldName = key.slice(0, -4) // e.g. 'appResource'
            const path = entitlementView[key]
            const expansionIndex = expandIndexFromPath(path)[0]
            const expansionElement = expansionItems[expansionIndex]
            const expansionType = EXPANSION_TYPES[expansionElement?.typeUrl]
            if (isFinite(expansionIndex) && expansionType) {
                try {
                    expanded[newFieldName] = Any.unpack(expansionElement, expansionType)
                } catch (e) {
                    console.error(e)
                }
            }
        }
    })

    return expanded as unknown as AppEntitlementViewExpanded
}
